export default __webpack_public_path__ + "slices/main/assets/public/media/masthead/geekly-thumb@2x.0bf73d0ee7b66e2077a6d5ddf3564987.png";